"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _dropdown = _interopRequireDefault(require("@insided/shared/uikit/dropdown"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _ChevronUp = _interopRequireDefault(require("@insided/shared/icons/ChevronUp"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _EventListOverview = require("@insided/deprecated-preact-components/Event/EventListOverview");

var _classnames = _interopRequireDefault(require("classnames"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var getFilterLabel = function getFilterLabel(key, label, isBugContentTypeEnabled) {
  if (isBugContentTypeEnabled && (key === 'discussion' || key === 'conversation')) {
    return (0, _preact.h)(_phrase.default, {
      m: "Forum",
      p: "topic.form.type.bug.label"
    });
  }

  return label;
};

var CategoryContentTypeFilters = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CategoryContentTypeFilters, _Component);

  var _super = _createSuper(CategoryContentTypeFilters);

  function CategoryContentTypeFilters() {
    var _this;

    (0, _classCallCheck2.default)(this, CategoryContentTypeFilters);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isOpen: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFilterChange", function (filterKey) {
      var onFilterChange = _this.props.onFilterChange;

      if (onFilterChange) {
        onFilterChange(filterKey);
      }

      _this.setState({
        isOpen: false
      });
    });
    return _this;
  }

  (0, _createClass2.default)(CategoryContentTypeFilters, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var isMobile = _EventListOverview.isClient && (0, _insidedDataStorage.getInsidedData)('device') === 'mobile';
      var _this$props = this.props,
          filters = _this$props.filters,
          activeContentType = _this$props.activeContentType,
          onFilterChange = _this$props.onFilterChange,
          isLoading = _this$props.isLoading,
          _this$props$isBugCont = _this$props.isBugContentTypeEnabled,
          isBugContentTypeEnabled = _this$props$isBugCont === void 0 ? false : _this$props$isBugCont;
      var isOpen = this.state.isOpen;

      if (!filters || filters.length <= 1) {
        return null;
      }

      var activeFilter = filters.find(function (filter) {
        return filter.key === activeContentType;
      });
      var activeFilterLabel = activeFilter ? getFilterLabel(activeFilter.key, activeFilter.label, isBugContentTypeEnabled) : '';

      if (isMobile) {
        return (0, _preact.h)(_dropdown.default, {
          closeOnDropdownClick: true,
          popupName: "content-type-filter-dropdown",
          className: "dropdown-selector",
          trigger: (0, _preact.h)(_Button.default, {
            title: activeFilterLabel,
            endIcon: isOpen ? (0, _preact.h)(_ChevronUp.default, {
              width: 16,
              height: 16
            }) : (0, _preact.h)(_ChevronDown.default, {
              width: 16,
              height: 16
            }),
            size: "medium",
            fullWidth: true,
            onClick: function onClick() {
              return _this2.setState({
                isOpen: !isOpen
              });
            },
            "data-qa": "select-content-type"
          }),
          triggerClass: "dropdown-selector-wrapper--control"
        }, (0, _preact.h)("ul", {
          className: "content-type-filter-dropdown__list"
        }, filters === null || filters === void 0 ? void 0 : filters.map(function (_ref) {
          var key = _ref.key,
              label = _ref.label;
          return (0, _preact.h)("li", {
            className: "content-type-filter-dropdown__item",
            key: key
          }, (0, _preact.h)(_Button.default, {
            variant: "text",
            title: getFilterLabel(key, label, isBugContentTypeEnabled),
            fullWidth: true,
            size: "medium",
            onClick: function onClick() {
              return _this2.handleFilterChange(key);
            }
          }));
        })));
      }

      return (0, _preact.h)("div", {
        className: "content-type-filters"
      }, (0, _preact.h)("div", {
        className: "content-type-filters__container"
      }, (0, _preact.h)("ul", {
        className: "content-type-filters__list"
      }, filters.map(function (_ref2) {
        var key = _ref2.key,
            label = _ref2.label;
        return (0, _preact.h)("li", {
          key: key,
          className: "content-type-filters__item"
        }, (0, _preact.h)(_Button.default, {
          variant: "text",
          size: "medium",
          noMargin: true,
          className: (0, _classnames.default)('content-type-filters__button', {
            active: activeContentType === key
          }),
          onClick: function onClick() {
            return onFilterChange(key);
          },
          "aria-pressed": activeContentType === key,
          disabled: isLoading
        }, (0, _preact.h)("span", {
          className: "content-type-filters__label"
        }, getFilterLabel(key, label, isBugContentTypeEnabled))));
      }))));
    }
  }]);
  return CategoryContentTypeFilters;
}(_preact.Component);

var _default = CategoryContentTypeFilters;
exports.default = _default;